import request from "@/utils/request";
//1, 获取学校列表
export function getSchoolList(data){
    return request({
        url:'/getUniversitys',
        data:data,
        method:'get'
    })
}


//1, 获取省份列表
export function getProvinces(data){
    return request({
        url:'/getProvinces',
        data:data,
        method:'get'
    })
}

//1, 获取所有国家
export function getCountries(data){
    return request({
        url:'/getCountries',
        data:data,
        method:'get'
    })
}
